import type { FaireProductEntity } from "../../entity_types/product";

export const p_zpqnx37cxq: FaireProductEntity = {
  token: "p_zpqnx37cxq",
  type: "product",
  name: "Called To Be Different Fish Spring Graphic Sweatshirt",
  brandToken: "b_ptxhxzu9rh",
  brandName: "Wholehearted Motherhood and Co.",
  imageUrl: "https://cdn.faire.com/fastly/965c5c50174bdd1b30a6310f9fb8f7bee34c42902da99addfc77fd1ec7c45607.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/beff3b6fa975a9c381167efa5974c3e36451a8cc7b6bb7435b5c7a9d900d4c60.jpeg",
    "https://cdn.faire.com/fastly/64fe0ceece83b5388ee0261645c2022cce4b3a8c999ada36a0e1391e46dc15d6.jpeg"
  ],
  priceDollars: 20,
  description: "Motherhood Graphic Sweatshirt -Trendy Western  Sweatshirt - Faith Graphic Sweatshirt - Christian Sweatshirt - Inspirational Sweatshirt - Spring Graphic Tee\n\nSuper Soft and Comfy Unisex 50/50 blend Crewneck Pullover.\n \nThis sweatshirt is super comfy and perfect for any season.\n \nThese are available in soft style Tees in our shop too!\n \nCare Instructions: We recommend washing inside out, cold water, gentle cycle. Tumble dry on low. Do not iron directly on design.",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:38.506Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
